module.exports = __webpack_public_path__ + "img/noises-2.bd402541.jpg";